import type { Mission } from '../missions.ts'

export const si: Mission = {
  id: "si",
  name: "Smithsonian Institution",
  short: "Smithsonian",
  call: "Discovery",
  kind: "independent",
  url: "https://www.si.edu/",
  established: 1846,
  palette: {
    primary: "#009ade",
    secondary: "#101820",
    accent: "#ffcd00",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Smithsonian_logo_color.svg",
  },
  motif: "sun",
  mission: {
    text: "The increase and diffusion of knowledge.",
    url: "https://www.si.edu/about/mission",
  },
  fact: {
    text: "The Smithsonian was founded with the estate of James Smithson, a British scientist who never set foot in the United States; President James K. Polk signed the act organizing it on August 10, 1846.",
    url: "https://www.si.edu/about/history",
  },
  seal: {
    file: "public/seals/si.svg",
    source: "https://commons.wikimedia.org/wiki/File:Smithsonian_sun_logo_no_text.svg",
  },
  logo: {
    file: "public/logos/si.svg",
    source: "https://commons.wikimedia.org/wiki/File:Smithsonian_logo_color.svg",
  },
  identifier: {
    about: "https://www.si.edu/about",
    accessibility: "https://www.si.edu/visit/accessibility",
    foia: "https://www.si.edu/ogc/records-requests",
    oig: "https://oig.si.edu/",
    performance: "https://www.si.edu/dashboard",
    privacy: "https://www.si.edu/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/si-castle.jpg",
        small: "/media/si-castle-sm.jpg",
        alt: "The red sandstone towers and battlements of the Smithsonian Institution Building rising above bare trees and a garden under a deep blue sky.",
        title: "The Smithsonian Institution Building, the Castle, on the National Mall, Washington, D.C.",
        creator: "Noclip, Wikimedia Commons",
        source: "https://commons.wikimedia.org/wiki/File:Smithsonian_Building_NR.jpg",
        license: "Public domain",
      },
      {
        file: "/media/si-henry.jpg",
        small: "/media/si-henry-sm.jpg",
        alt: "The north entrance of the Smithsonian Castle, with its rose window and tall towers, behind the bronze statue of Joseph Henry, the first Secretary.",
        title: "Smithsonian Institution Building and the Joseph Henry statue, April 25, 2021",
        creator: "Kurt Kaiser",
        source: "https://commons.wikimedia.org/wiki/File:Smithsonian_Institution_Building_2.jpg",
        license: "CC0 1.0",
      },
    ],
  },
}
